import React, { useEffect, useState } from "react";
import { Megaphone, Users, TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Page, Card, StatCard } from "../components/UI";
import api from "../lib/api";

export default function Marketing() {
  const [report, setReport] = useState({ total_clients: 0, referral_sources: [], active_caseload: 0 });

  useEffect(() => {
    api.get("/marketing/report").then(({ data }) => setReport(data));
  }, []);

  return (
    <Page title="Practice Marketing" subtitle="Referral sources, growth metrics, and practice health.">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-5">
        <StatCard label="Total Clients" value={report.total_clients} icon={Users} accent="var(--mf-primary)" delay={0.05} testid="mkt-total-clients" />
        <StatCard label="Active Caseload" value={report.active_caseload} icon={Users} accent="var(--mf-secondary)" delay={0.1} testid="mkt-caseload" />
        <StatCard label="Referral Channels" value={report.referral_sources.length} icon={Megaphone} accent="var(--mf-accent)" delay={0.15} testid="mkt-channels" />
      </div>

      <Card delay={0.2} testid="mkt-referral-chart">
        <h3 className="font-serif text-xl mb-4">Referral Sources</h3>
        <div className="h-64">
          {report.referral_sources.length === 0 ? (
            <div className="h-full flex items-center justify-center text-sm" style={{ color: "var(--mf-text-muted)" }}>No referral data yet.</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={report.referral_sources}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.05)" />
                <XAxis dataKey="source" stroke="var(--mf-text-muted)" style={{ fontSize: "12px" }} />
                <YAxis stroke="var(--mf-text-muted)" style={{ fontSize: "12px" }} />
                <Tooltip contentStyle={{ background: "var(--mf-surface)", border: "none", borderRadius: "12px" }} />
                <Bar dataKey="count" fill="var(--mf-primary)" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </Card>

      <Card delay={0.25} className="mt-5" testid="mkt-health-report">
        <div className="flex items-center gap-2 mb-3">
          <TrendingUp className="w-5 h-5" style={{ color: "var(--mf-accent)" }} />
          <h3 className="font-serif text-xl">Monthly Practice Health</h3>
        </div>
        <ul className="text-sm space-y-2" style={{ color: "var(--mf-text-muted)" }}>
          <li>• Total clients served: <strong style={{ color: "var(--mf-text)" }}>{report.total_clients}</strong></li>
          <li>• Active caseload: <strong style={{ color: "var(--mf-text)" }}>{report.active_caseload}</strong></li>
          <li>• Top referral source: <strong style={{ color: "var(--mf-text)" }}>{report.referral_sources[0]?.source || "None"}</strong></li>
          <li>• SEO-ready therapist profile page and Google review automation coming soon.</li>
        </ul>
      </Card>
    </Page>
  );
}
